"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function checkNavigator(testExp) {
    // Depending on the execution environment, navigator might either be undefined or throw a ReferenceError.
    try {
        return testExp.test(navigator.userAgent);
    }
    catch (_a) {
        return false;
    }
}
exports.isIE = checkNavigator(/Trident/);
exports.isEdge = checkNavigator(/Edge\//);
exports.isMac = checkNavigator(/Mac/);
/**
 * Platform-aware version of `e.ctrlKey`
 */
function isCtrl(event) {
    if (exports.isMac) {
        return event.metaKey || event.ctrlKey;
    }
    else {
        return event.ctrlKey;
    }
}
exports.isCtrl = isCtrl;
//# sourceMappingURL=BrowserDetection.js.map